import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';


@Component({
  selector: 'app-customerupdate',
  templateUrl: './customerupdate.component.html',
  styleUrls: ['./customerupdate.component.css']
})
export class CustomerupdateComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  copyButton1: boolean = true;
  copiedButton1: boolean = false;
  
  showVod = false;
  showImg = false;
  showemail = false;
  showStorage = false;

  show1 = false; // primary_storages
  show2 = false; // upscaler_process_settings
  show3 = false; // optimizer_process_settings	  
  show4 = false; // upscaler_file_management_properties
  show5 = false; // optimizer_file_management_properties

  showimg1 = false;
  showimg2 = false;
  showimg3 = false;
  showimg4 = false;
  showimg5 = false;
  showimg6 = false;

  constructor() {}

  ngOnInit(): void {
  }


  requestData =
    `curl 'https://api.optimusdrive.ai/v1/customer/update' \ -X 'PUT' \ -H 'authorization: oXXg' \ --data-raw 
'{ 

  "notification_email": "atest1_1@yxyzl.com", 
  "image": { 
    "upscaler_process_settings": { 
      "type": "4x", 
      "ask_me_every_time": true 
    }, 
    "upscaler_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    }, 
    "optimizer_process_settings": { 
      "type": "quality", 
      "ask_me_every_time": true 
    }, 

    "optimizer_file_management_properties": { 
      "file_copy_preference": "create_copy", 
      "ask_me_every_time": false 
    }, 
    "enhancer_process_settings": { 
      "type": "2x", 
      "ask_me_every_time": false 
    }, 
    "enhancer_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    } 
  }, 
  "vod": { 
    "upscaler_process_settings": { 
      "type": "1080p", 
      "ask_me_every_time": true 
    }, 
    "optimizer_process_settings": { 
      "type": "size", 
      "ask_me_every_time": false 
    }, 
    "upscaler_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    }, 
    "optimizer_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    }
  }, 
  "email_notification_settings": { 
    "notify_when_file_processed": true, 
    "notify_when_limit_reached": true 
  } 
}'
`




  sucessData = `
  {
    "data": {
      "id": "934c51b-cd6c-4335d-8e38-4ff27d27b007",
      "user_type": "",
      "name": "AbXYZit",
      "family_name": "GXYZa",
      "email": "abhiXYZd_1@yoxyzail.com",
      "company_name": "",
      "credits": 249.25333333333333,
      "updated_at": 1694503321,
      "vod": {
        "media_preset_id": "8f2c93f6-6603-4ad8-a774-5fbe63428a6f",
        "media_preset_name": "default",
        "transcoder_preset_id": "a9ceebde-1ac0-4505-9f9c-ebfdeaa3910a",
        "transcoder_preset_name": "default",
        "input_bucket": "cmw-optimus-media",
        "output_bucket": "cmw-optimus-media",
        "region": "us-east-1",
        "managed_by": "crunch",
        "is_configured": "true",
        "primary_use": "Both",
        "primary_storages": [
          {
            "provider": "oci",
            "is_connected": false
          },
          {
            "provider": "googledrive",
            "is_connected": false
          },
          {
            "provider": "dropbox",
            "is_connected": false
          },
          {
            "provider": "s3",
            "is_connected": false
          }
        ],
        "upscaler_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "optimizer_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "upscaler_process_settings": {
          "type": "1080p",
          "ask_me_every_time": true
        },
        "optimizer_process_settings": {
          "type": "size",
          "ask_me_every_time": false
        }
      },
      "image": {
        "upscaler_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "upscaler_process_settings": {
          "type": "4x",
          "ask_me_every_time": true
        },
        "optimizer_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "create_copy"
        },
        "optimizer_process_settings": {
          "type": "quality",
          "ask_me_every_time": true
        },
        "enhancer_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "enhancer_process_settings": {
          "type": "2x",
          "ask_me_every_time": false
        }
      },
      "email_notification_settings": {
        "notify_when_file_processed": true,
        "notify_when_limit_reached": true,
        "account_related_notification": true
      },
      "storage_connection_details": {
        "dropbox": false,
        "googledrive": false,
        "oci": false,
        "s3": true
      }
    },
    "message": "User updated successfully"
  }
  `
 


  Error4x = `
{
  "error": "invalid character ':' after object key:value pair",
    "message": "Invalid request, Please check your request body and try again!"
}
`

  Error42x = `
{
  "error": [
    {
      "User.VodUser.UpscalerSettings.Type":
        "Key: 'User.VodUser.UpscalerSettings.Type' 
            Error: Field validation for 'Type' failed on the 'oneof' tag"
        }
  ],
    "message": "Validation Error"
} `


  Error401x=`
{
  "error": { },
  "message": "Unauthorized"
}
`
  
  example2RequestData = `
{
  "name": "test",
    "notification_email": "notificationemail@domain.com",
      "vod": {
    "primary_use": "business",
      "primary_storages": [
        {
          "provider": "s3"
        },
        {
          "provider": "oci"
        }
      ]
  },
  "email_notification_settings": {
    "notify_when_file_processed": true,
      "notify_when_limit_reached": true,
        "account_related_notification": true
  }
} `


  sucessData2 = `
{
  "data": {
    "id": "bc96e670-4450-42c1-a53c-5175182040e2",
      "user_type": "",
        "name": "test",
          "family_name": "Gupta",
            "email": “TES @yopmail.com",
    "company_name": "",
      "updated_at": 1689160017,
        "vod": {
      "media_preset_id": "8f2c93f6-6603-4ad8-a774-5fbe63428a6f",
        "media_preset_name": "default",
          "transcoder_preset_id": "a9ceebde-1ac0-4505-9f9c-ebfdeaa3910a",
            "transcoder_preset_name": "default",
              "input_bucket": "cmw-optimus-media",
                "output_bucket": "cmw-optimus-media",
                  "region": "us-east-1",
                    "managed_by": "crunch",
                      "is_configured": "true",
                        "optimizer_max_duration": 3600,
                          "optimizer_utilized_duration": 162,
                            "upscaler_max_duration": 3600,
                              "upscaler_utilized_duration": 12,
                                "primary_use": "business",
                                  "primary_storages": [
                                    {
                                      "provider": "s3",
                                      "is_connected": false
                                    },
                                    {
                                      "provider": "oci",
                                      "is_connected": true
                                    }
                                  ],
                                    "upscaler_file_management_properties": {
        "ask_me_every_time": true,
          "file_copy_preference": "manual_copy"
      },
      "optimizer_file_management_properties": {
        "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
      },
      "upscaler_process_settings": {
        "type": "1080p",
          "ask_me_every_time": false
      },
      "optimizer_process_settings": {
        "type": "size",
          "ask_me_every_time": true
      }
    },
    "email_notification_settings": {
      "notify_when_file_processed": true,
        "notify_when_limit_reached": true,
          "account_related_notification": true
    }
  },
  "message": "User updated successfully"
} `




  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.example2RequestData);
  }


  // example 1

  copyToClipBoard1(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton1 = false;
       this.copiedButton1 = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton1 = true;
        this.copiedButton1 = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard1() {
    this.copyToClipBoard1(this.requestData);
  }

}
